module.exports = __webpack_public_path__ + "images/emoji/japan.9c5d88c69033fdf4de3a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/japan.png
// module id = wTxC
// module chunks = 24